/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import IFamilias from 'Infotrack@Modelos/smartStock/familias/entidades/familias';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorIndicadorCargaGlobal,
    manejadorDialogoGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FamiliasCM from '../controladorModelo/familiasCM';
import { acciones, IEstadoFamilias } from '../reductorFamilias';
import FamiliasVista from '../vista/tablaFamiliasVista';
import Texto from '@infotrack/presentacion-componentes/texto';
import { useSelector } from 'react-redux';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';

const familiasCM = new FamiliasCM();

const TableFamiliasCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [familiass, setFamiliass] = React.useState<IFamilias[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoFamilias>();
    const idEmpresa = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdEmpresa);
    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarFamilias();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarFamilias = () => {
        manejadorIndicadorCargaGlobal(true);
        familiasCM.consultarFamiliasPoFiltro({EmpresaId:idEmpresa}).then((familiass) => {
            setFamiliass(familiass);
            manejadorIndicadorCargaGlobal(false);
        });
    };
    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadFamilias?: IFamilias) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadFamilias, tipoFormulario } });
    };

    const confirmarEliminacion = (familias: IFamilias) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarFamilias(familias),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const eliminarFamilias = (familias: IFamilias) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        familiasCM.eliminarFamilias(familias).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <FamiliasVista
            familiass={familiass}
            cargarFamilias={cargarFamilias}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableFamiliasCV;
